import { mixpanelObject } from 'src/utils/analytics';

import {
  parentalOverlay,
  parentalOverlayResult
} from '../../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import {
  MIXPANEL_TALAMOOS_MODELNAME,
  MIXPANEL_CAROUSAL_ID,
  MIXPANEL_CAROUSAL_NAME,
  MIXPANEL_SUCCESS,
  MIXPANEL_FAILURE_REASON
} from '../../../../utils/analytics/mixpanel/mixpanelConstants';

type ParentalPopupProps = {
  playerRef: any;
  closePopUp: any;
};

const ParentalPopup = ({ playerRef, closePopUp }: ParentalPopupProps) => {
  let values1: any;
  let values2: any;
  let values3: any;
  let values4: any;
  let errorMsg: any;

  const parentControlUnlock = (parentLockPin: any) => {
    const { playerConfig = {}, singlePlayDetails = {} } = playerRef || {};
    const { parentalControlPin = '' } = singlePlayDetails || {};
    const { getSinglePlayDetails = null } = playerConfig || {};
    const incorrectMsgField = document.getElementById('incorrectPin');
    const parentPinDiv = document.getElementById('parentlock');
    let payload;
    const mixpanelData = {
      talamoosModelname: mixpanelObject[MIXPANEL_TALAMOOS_MODELNAME],
      carousalId: mixpanelObject[MIXPANEL_CAROUSAL_ID],
      carouselName: mixpanelObject[MIXPANEL_CAROUSAL_NAME]
    };
    if (Number(parentalControlPin) === Number(parentLockPin)) {
      if (parentPinDiv !== null) {
        closePopUp();
      }
      payload = {
        success: true,
        failureReason: 'N/A',
        autoplay: true,
        mixpanelData
      };
      getSinglePlayDetails({
        contentId: playerConfig.contentId,
        assetSubType: singlePlayDetails?.assetDetails?.asset_subtype,
        id: singlePlayDetails?.assetDetails?.id,
        parentalPinStatus: false,
        parentalPinFlag: true
      });
    } else {
      window.parentalPinIncorrect = true;
      if (incorrectMsgField) {
        incorrectMsgField.style.display = 'block';
      }
      //   empty all the pin inputs if the entered code is incorrect
      for (let i = 1; i < 5; i += 1) {
        const parentalLockId = document.querySelector(
          `#parentLockId${i}`
        ) as HTMLInputElement;
        if (parentalLockId) {
          parentalLockId.value = '';
        }
      }
      //  once clearing the inputs, focus the first input
      const parentalLockId1 = document.querySelector(
        `#parentLockId1`
      ) as HTMLInputElement;
      if (parentalLockId1) {
        parentalLockId1.focus();
      }
      payload = {
        success: false,
        failureReason: 'Incorrect PIN. Please try again!',
        autoplay: true,
        mixpanelData
      };
    }
    mixpanelObject[MIXPANEL_SUCCESS] = payload.success;
    mixpanelObject[MIXPANEL_FAILURE_REASON] = payload.failureReason;
    parentalOverlayResult(payload);
  };

  const compareParentalValue = () => {
    const pinArray = [];
    pinArray.push(values1.value, values2.value, values3.value, values4.value);
    const parentLockPin = pinArray.join('');
    parentControlUnlock(parentLockPin);
  };

  const validatePin = (currentVal: any, previousVal: any, nextVal: any) => {
    if (
      currentVal?.value.length === Number(currentVal?.getAttribute('maxlength'))
    ) {
      if (
        values1?.value &&
        values2?.value &&
        values3?.value &&
        values4?.value
      ) {
        compareParentalValue();
      } else {
        errorMsg.style.display = 'none';
        nextVal.focus();
      }
    } else if (currentVal.value.length === 0) {
      errorMsg.style.display = 'none';
      previousVal.focus();
    }
  };

  const onKeyUpHandler = (event: any) => {
    values1 = document.getElementById('parentLockId1') || null;
    values2 = document.getElementById('parentLockId2') || null;
    values3 = document.getElementById('parentLockId3') || null;
    values4 = document.getElementById('parentLockId4') || null;
    errorMsg = document.getElementById('incorrectPin') || null;
    switch (event.target.id) {
      case 'parentLockId1':
        validatePin(values1, values1, values2);
        break;
      case 'parentLockId2':
        validatePin(values2, values1, values3);
        break;
      case 'parentLockId3':
        validatePin(values3, values2, values4);
        break;
      case 'parentLockId4':
        validatePin(values4, values3, values4);
        break;
      default:
        break;
    }
  };

  const mixpanelData = {
    talamoosModelname: mixpanelObject[MIXPANEL_TALAMOOS_MODELNAME],
    carousalId: mixpanelObject[MIXPANEL_CAROUSAL_ID],
    carouselName: mixpanelObject[MIXPANEL_CAROUSAL_NAME],
    autoplay: true
  };
  parentalOverlay(mixpanelData);

  return (
    <div
      id="parentlock"
      className="parentlockContainer"
      data-testid="parental-pin-pop-up-container">
      <div id="childDivId" className="parentLock">
        <div id="enterPin" className="enterPinMsg">
          Enter your 4 digit Pin
        </div>
        <input
          id="parentLockId1"
          onKeyUp={onKeyUpHandler}
          className="parentLockInput"
          type="password"
          pattern="[0-9]*"
          inputMode="numeric"
          maxLength={1}
          autoFocus
          data-testid="parental-pin-player-input-1"
        />
        <input
          id="parentLockId2"
          onKeyUp={onKeyUpHandler}
          className="parentLockInput"
          type="password"
          pattern="[0-9]*"
          inputMode="numeric"
          maxLength={1}
          data-testid="parental-pin-player-input-2"
        />
        <input
          id="parentLockId3"
          onKeyUp={onKeyUpHandler}
          className="parentLockInput"
          type="password"
          pattern="[0-9]*"
          inputMode="numeric"
          maxLength={1}
          data-testid="parental-pin-player-input-3"
        />
        <input
          id="parentLockId4"
          onKeyUp={onKeyUpHandler}
          className="parentLockInput"
          type="password"
          pattern="[0-9]*"
          inputMode="numeric"
          maxLength={1}
          data-testid="parental-pin-player-input-4"
        />
        <div
          id="incorrectPin"
          className="incorrectPinMsg"
          style={{ display: 'none' }}>
          Incorrect PIN. Please try again!
        </div>
      </div>
    </div>
  );
};

export default ParentalPopup;
